<template>
    <div class="share-wrapper">
        <span>Deel via:</span>
        <a :href="twitterLink" target="_blank"><img src="static/img/twitter-icon.png"/></a>
        <a @click="fbShare"><img src="static/img/facebook-icon.png" /></a>
        <a v-if="isMobile" :href="whatsappLink"><img src="static/img/whatsapp-icon.png" /></a>
    </div>
</template>

<style lang="scss" scoped>

</style>

<script>
    export default {
        data()
        {
            return {
                isMobile: this.$helpers.browserCheck().isMobile
            };
        },

        computed: {
            twitterLink()
            {
                let text = 'Speel het Staatsloterijspel en maak kans op 10 loten voor de 10 augustus trekking! ' + window._rootData.apiUrl;
                let hashtags = [];

                let twitterLink = 'http://twitter.com/intent/tweet?text=' + encodeURIComponent( text ) + '&hashtags=' + hashtags.join( ', ' );

                return twitterLink;
            },

            whatsappLink()
            {
                let text = 'Speel het Staatsloterijspel en maak kans op 10 loten voor de 10 augustus trekking! ' + window._rootData.apiUrl;
                let whatsappLink = 'whatsapp://send?text=' + encodeURIComponent( text );
                return whatsappLink;
            }
        },

        methods: {
            fbShare()
            {
                window.FB.ui(
                    {
                        method: 'share',
                        href: window._rootData.apiUrl + '/share/'// + this.$store.getters['getEntry'].id
                    },
                    function( response )
                    {
                        if( response && !response.error_message )
                        {
                            // console.log( 'Posting completed.' );
                            // return;
                        }
                        // console.log( 'Error while posting.' );
                    }
                );
            }
        }
    };
</script>



// WEBPACK FOOTER //
// src/app/components/Shares.vue